import script from "./ParmSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ParmSettings.vue?vue&type=script&setup=true&lang=js"

import "./ParmSettings.vue?vue&type=style&index=0&id=5cd3f9ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd3f9ed"]])

export default __exports__